<template>
  <centered-card :headline="headline">
      <div class="mb-4">
        <input type="text" v-model="search" placeholder="filter blogs" class="form-control">
      </div>

      <loading-indicator name="user.follows"/>
      <blog v-for="blog in filteredBlogs" :blog="blog" :key="blog._id"/>
  </centered-card>
</template>

<script>

    import Blog from '../blogs/BlogListItemSmall.vue';
    import LoadingIndicator from "../ui/LoadingIndicator";
    import CenteredCard from "../layout/CenteredCard";

    export default {
        name: 'FollowedBlogs',
        metaInfo: {
            title: 'Blogs you are Following'
        },
        data() {
            return {
                blogs: [],
                search: '',
                isActive: false
            }
        },
        computed: {
          filteredBlogs() {
            if (this.search.length > 0) {
              return this.blogs.filter(blog => blog.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 )
            } else {
              return this.blogs;
            }
          },
          headline() {
            let str = 'Followed Blogs';
            const len = this.filteredBlogs.length;
            if (len > 0) str += ` (${len})`;
            return str;
          }
        },
        mounted(){
            this.isActive = true;

            this.$bus.$on('bloglist.exists', (data)=>{
              if(this.isActive) this.$bus.$emit('blog-modal.listExists', this.getNextPrevBlogs(data.currentBlog));
            });

            this.$api.getUserFollowdBlogs()
                .then((res)=>{
                    this.blogs = res.data.blogs
                })
        },
        beforeDestroy() {
          this.isActive = false;
        },
        methods: {
          getNextPrevBlogs(current){
            let last = null;
            let next = null;
            for(let i in this.filteredBlogs){
              const b = this.filteredBlogs[i];
              if(b === current){
                next = 1;
                continue;
              }
              if(next === 1){
                next = b;
                break;
              }
              last = b;
            }
            if(next === 1) next = null;
            return {
              nextBlog: next,
              prevBlog: last
            }
          }
        },
        components:{
          CenteredCard,
          LoadingIndicator,
            Blog
        }

    }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/user/FollowedBlogsList.vue